module.exports = __webpack_public_path__ + "fonts/IBMPlexMono-Regular.fc89cc27.ttf";